/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Publish_DescInputs */

const en_pb_publish_desc = /** @type {(inputs: Pb_Publish_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put a bystep-playbook.json like this at the root of a public GitHub project and add the topic bystep-playbook. It appears here within 30 minutes, marked as community.`)
};

const id_pb_publish_desc = /** @type {(inputs: Pb_Publish_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taruh berkas bystep-playbook.json seperti ini di akar repositori GitHub publik dan tambahkan topik bystep-playbook. Dalam 30 menit ia muncul di sini dengan tanda komunitas.`)
};

/**
* | output |
* | --- |
* | "Put a bystep-playbook.json like this at the root of a public GitHub project and add the topic bystep-playbook. It appears here within 30 minutes, marked as c..." |
*
* @param {Pb_Publish_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_publish_desc = /** @type {((inputs?: Pb_Publish_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Publish_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_publish_desc(inputs)
	return en_pb_publish_desc(inputs)
});